export default {
	CriteriaSetups: []
};
